import AxiosApi from "@/config/axios";

const PersonInfoService = {};

PersonInfoService.getInfos = () => {
    return AxiosApi({
        url: `/person-info`,
        method: 'get',
    })
}

export default PersonInfoService;